export const GET_ELECTRONICS_REQUEST = "GET_ELECTRONICS_REQUEST";
export const GET_ELECTRONICS_SUCCESS = "GET_ELECTRONICS_SUCCESS";
export const GET_ELECTRONICS_ERROR = "GET_ELECTRONICS_ERROR";
